export function tooltipEvents(context) {
    $(".js-show-tooltip", context).tooltip();
    $(".js-toast", context).toast("show");
    $('[data-toggle="popover"]').popover();
}
